<template>
  <div class="template_box">
    <div class="temp_t">
      <div class="temp_t_btn" @click="openColorDialog">新增颜色</div>
      <!-- <div> -->
        <el-input class="temp_t_search"
          placeholder="中文名称、英文名称或16进制值"
          v-model="searchForm.keyword">
          <span slot="suffix" @click="tableSearch">
            搜索 <img src="@/assets/images/search.png">
          </span>
        </el-input>
      <!-- </div> -->
    </div>
    <el-table
      :data="tableData"
      class="main_table">
      <!-- <el-table-column
        type="selection"
        width="55" /> -->
      <el-table-column
        prop="name_zh"
        label="颜色名称" />
      <el-table-column
        prop="name_en"
        label="英文名称" />
      <el-table-column
        label="十六进制 / 颜色展示">
        <template slot-scope="scope">
          <span class="table_color_text">{{scope.row.hex_value}}</span>
          <span :style="{background: scope.row.hex_value}" class="table_color"></span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
          <!-- <el-button type="text" @click="specifyShared(scope.row)">共享</el-button>
          <el-button type="text" @click="removeSingle(scope.row)">移动到</el-button> -->
          <el-button type="text" style="color: #F72D2D" @click="handleDelete(scope.row.id)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="main_pagination"
      background
      @current-change="handleCurrentChange"
      layout="prev, pager, next"
      :page-size="searchForm.limit"
      :total="tableTotal">
    </el-pagination>
    <el-dialog class="main_dialog" :show-close="false" :title="ruleForm.id ? '编辑颜色' : '新增颜色'" width="470px" :visible.sync="dialogColorVisible">
      <el-form :model="ruleForm" :rules="rules" label-position="top" ref="ruleForm" hide-required-asterisk>
        <el-form-item label="颜色名称" prop="name_zh">
          <el-input v-model="ruleForm.name_zh" placeholder="请填写颜色名称"></el-input>
        </el-form-item>
        <el-form-item label="英文名称" prop="name_en">
          <el-input v-model="ruleForm.name_en" placeholder="请填写英文名称"></el-input>
        </el-form-item>
        <el-form-item label="颜色十六进制值" prop="hex_value">
          <el-input v-model="ruleForm.hex_value" placeholder="请填写十六进制值"></el-input>
        </el-form-item>
      </el-form>
      <el-button class="dialog_confirm" size="small" @click="handleSubmitForm">确 定</el-button>
      <el-button class="dialog_cancel" size="small" @click="dialogColorVisible = false">取 消</el-button>
    </el-dialog>
  </div>
</template>
<script>
import { colorGetList, colorCreate, colorUpdate, colorDelete } from '@/api/template'
export default {
  name: "template",
  data () {
   return {
    searchForm: {
      keyword: '',
      page: 1,
      limit: 10
    },
    tableTotal: 0,
    tableData: [],

    dialogColorVisible: false,
    ruleForm: {
      name_zh: '',
      name_en: '',
      hex_value: ''
    },
    rules: {
      name_zh: [{required: true, max: 50, message: '请输入颜色名称', trigger: 'blur'}],
      name_en: [{required: true, max: 50, message: '请输入英文名称', trigger: 'blur'}],
      hex_value: [{required: true, pattern: /^#?([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/, message: '请输入16进制色值', trigger: 'blur'}],
    }
   }
  },
  created() {
    this.getColorList()
  },
  methods:{
    openColorDialog() {
      if(this.ruleForm.id) {
        delete this.ruleForm.id
      }
      this.ruleForm.name_zh = ''
      this.ruleForm.name_en = ''
      this.ruleForm.hex_value = ''
      this.dialogColorVisible = true
      
    },
    handleEdit(row) {
      this.ruleForm.id = row.id
      this.ruleForm.name_zh = row.name_zh
      this.ruleForm.name_en = row.name_en
      this.ruleForm.hex_value = row.hex_value
      this.dialogColorVisible = true
    },
    handleSubmitForm() {
      this.$refs.ruleForm.validate(valid => {
        if(valid) {
          if(this.ruleForm.id) {
            colorUpdate(this.ruleForm.id, this.ruleForm).then(res => {
              this.$message.success('编辑颜色成功')
              this.dialogColorVisible = false
              this.getColorList()
            })
          }else {
            colorCreate(this.ruleForm).then(res => {
              this.$message.success('新增颜色成功')
              this.dialogColorVisible = false
              this.getColorList()
            })
          }
          
        }
      })
      // this.$router.push('/teamResource/template/detail')
    },
    handleDelete(id) {
      this.$confirm('是否删除该颜色?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        colorDelete(id).then(res => {
          this.$message.success('删除颜色成功')
          this.getColorList()
        })
      })
    },
    getColorList() {
      colorGetList(this.searchForm).then(res => {
        this.tableData = res.data.data
        this.tableTotal = res.data.total
      })
    },
    tableSearch() {
      this.searchForm.page = 1
      this.getColorList()
    },
    handleCurrentChange(val) {
      this.searchForm.page = val
      this.getColorList()
    }
  }
}
</script>
<style lang="scss" scoped>
.template_box {
  border-radius: 8px;
  background: #FFFFFF;
  padding: 24px 16px;
  .temp_t {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .temp_t_btn {
      border-radius: 8px;
      background: linear-gradient(90deg, #132632 0%, #3E4B4F 100%);
      font-size: 20px;
      font-weight: 500;
      color: #F7F8FA;
      width: 171px;
      height: 48px;
      text-align: center;
      line-height: 48px;
      cursor: pointer;
    }
    .temp_t_search {
      width: 321px;
      margin-right: 20px;
      /deep/ .el-input__inner {
        border-radius: 26px;
        background: #F2F3F5;
        height: 48px;
        line-height: 48px;
        padding-right: 90px;
        color: #737373;
      }
      /deep/ .el-input__suffix {
        border-radius: 18px;
        background: linear-gradient(90deg, #4691E7 0%, #3186E5 100%);
        height: calc(100% - 12px);
        top: 6px;
        width: 84px;
        line-height: 36px;
        font-size: 12px;
        color: #FFFFFF;
        cursor: pointer;
        img {
          vertical-align: text-top;
          margin-left: 4px;
        }
      }
    }
  }
  .table_color_text {
    display: inline-block;
    width: 98px;
  }
  .table_color {
    border-radius: 2px;
    border: 1px solid #EDEDED;
    display: inline-block;
    width: 67px;
    height: 12px;
  }
}
</style>